import { createFileRoute } from '@tanstack/react-router'
import { serviceSitePageSearchSchema } from '../../../../features/service/sites/search'
import { ServiceSitePage } from '../../../../features/service/sites/site-page'

export const Route = createFileRoute('/_app/service/sites/$siteId')({
  staticData: { crumb: 'serviceSite' },
  validateSearch: serviceSitePageSearchSchema,
  component: ServiceSitePage,
})
